import { render, staticRenderFns } from "./iHandUserEditor.vue?vue&type=template&id=6e478a18"
import script from "./iHandUserEditor.vue?vue&type=script&lang=js"
export * from "./iHandUserEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports